/* Hexoskin research lead capture loader. RC3, 2026-09-21; 2026-09-29: gtm_segment, gtm_sub_segment, background scroll lock.
 * Replaces forms.js. Mounts the HubSpot form for the clicked CTA inside dialog#lead,
 * sets the hidden attribution fields per click, and keeps one submission per open.
 * Requires: forms-config.json served next to this file (or inline as window.HEXO_LEAD_CONFIG).
 * Markup contract (unchanged from RC3): dialog#lead > button.close, h2#form-heading, p (intro), then a mount
 * element: replace the local mock <form id="lead-form"> with <div id="hs-lead-mount"></div><p role="status" id="status"></p>.
 * Every trigger keeps data-request="project|quote", data-context="<context>", data-cta-id="<stable id>".
 */
(function () {
  'use strict';
  var dialog = document.getElementById('lead');
  if (!dialog) return;
  var heading = document.getElementById('form-heading');
  var intro = dialog.querySelector('p');
  var mount = document.getElementById('hs-lead-mount');
  var status = document.getElementById('status');
  var closeBtn = dialog.querySelector('.close');
  var config = window.HEXO_LEAD_CONFIG || null;
  var scriptPromise = null;
  var lastTrigger = null;
  var submitted = false;
  var mounting = false;

  function setStatus(text, kind) {
    if (!status) return;
    status.textContent = text || '';
    status.className = kind ? 'hs-status hs-status-' + kind : 'hs-status';
  }

  function loadConfig() {
    if (config) return Promise.resolve(config);
    return fetch('forms-config.json', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('forms-config.json ' + r.status);
      return r.json();
    }).then(function (c) { config = c; return c; });
  }

  function loadScript(src) {
    if (window.hbspt && window.hbspt.forms) return Promise.resolve();
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.defer = true;
      s.onload = function () { (window.hbspt && window.hbspt.forms) ? resolve() : reject(new Error('hbspt missing')); };
      s.onerror = function () { scriptPromise = null; reject(new Error('embed script failed')); };
      document.head.appendChild(s);
    });
    return scriptPromise;
  }

  function utmString() {
    var p = new URLSearchParams(window.location.search), out = [];
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      var v = p.get(k); if (v) out.push(k.replace('utm_', '') + '=' + v.slice(0, 120));
    });
    return out.join(';');
  }

  function sectionOf(el) {
    var sec = el.closest('section, .section, .hero, .programme');
    var h = sec ? sec.querySelector('h1, h2, h3') : null;
    return h ? h.textContent.trim().slice(0, 200) : document.title.slice(0, 200);
  }

  /* Attribution is computed from the trigger element and the page only. Nothing is read from
   * arbitrary URL parameters into contact fields; UTM values are copied verbatim into lead_utm only. */
  function attribution(trigger) {
    var request = trigger.dataset.request === 'quote' ? 'quote' : 'project';
    var ctxKey = trigger.dataset.context || 'Research';
    var ctx = config.contexts[ctxKey] || config.contexts['Research'];
    var intent = request === 'quote' ? config.intentValues.quote : (ctx.projectIntent || config.intentValues.project);
    return {
      request: request,
      values: {
        research_audience: ctx.research_audience || '',
        lead_intent: intent,
        product_interest: (ctx.product_interest || []).join(';'),
        platform_context: ctx.platform_context || ctxKey,
        lead_cta_id: trigger.dataset.ctaId || '',
        lead_source_page: window.location.href.split('#')[0].slice(0, 500),
        lead_source_section: sectionOf(trigger),
        lead_utm: utmString(),
        source: 'Lead Capture Form',
        hs_language: (document.documentElement.lang || 'en').slice(0, 2),
        gtm_segment: ctx.gtm_segment || '',
        gtm_sub_segment: subSegmentOf(trigger)
      }
    };
  }

  function styleFormButtons(formEl) {
    if (!formEl || !formEl.ownerDocument) return;
    var doc = formEl.ownerDocument;
    if (doc.getElementById('hexo-form-button-colors')) return;
    var style = doc.createElement('style');
    style.id = 'hexo-form-button-colors';
    style.textContent = '.hs-form .hs-button{background:#0088ce!important;border-color:#0088ce!important;color:#fff!important;transition:background-color .2s ease,border-color .2s ease,color .2s ease}.hs-form .hs-button:hover,.hs-form .hs-button:focus-visible{background:#154067!important;border-color:#154067!important;color:#fff!important}.hs-form .hs-button:focus-visible{outline:3px solid #0088ce;outline-offset:3px}@media(prefers-reduced-motion:reduce){.hs-form .hs-button{transition:none}}';
    doc.head.appendChild(style);
  }

  /* GTM sub-segment (S3a..S3f): data-subsegment on the trigger wins, else the nearest ancestor carrying
   * data-lead-subsegment (the Human Performance & Safety page sets it from the selected research setting). */
  function subSegmentOf(trigger) {
    if (trigger.dataset.subsegment) return trigger.dataset.subsegment;
    var host = trigger.closest('[data-lead-subsegment]');
    return host ? (host.getAttribute('data-lead-subsegment') || '') : '';
  }

  function setHidden(formEl, name, value) {
    var inputs = formEl.querySelectorAll('[name="' + name + '"]');
    if (!inputs.length) return false;
    inputs.forEach(function (input) {
      if (input.type === 'checkbox') {
        input.checked = value.split(';').indexOf(input.value) !== -1;
      } else {
        input.value = value;
      }
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return true;
  }

  function clearMount() {
    while (mount.firstChild) mount.removeChild(mount.firstChild);
  }

  function mountForm(trigger) {
    if (mounting) return;
    mounting = true; submitted = false;
    clearMount(); /* never rely on the dialog close event; a hidden document may defer it */
    var a = attribution(trigger);
    var form = config.forms[a.request];
    heading.textContent = form.heading;
    if (intro) intro.textContent = a.request === 'quote'
      ? 'Tell us what you need and we will prepare a quote.'
      : 'Describe your protocol or project and we will reply with the next step.';
    mount.setAttribute('aria-busy', 'true');
    setStatus('Loading the form…', 'loading');
    loadScript(config.embedScript).then(function () {
      window.hbspt.forms.create({
        region: config.region,
        portalId: config.portalId,
        formId: form.formId,
        target: '#hs-lead-mount',
        onFormReady: function ($form) {
          var formEl = ($form && $form.jquery) ? $form[0] : ($form && $form.nodeType ? $form : mount.querySelector('form'));
          styleFormButtons(formEl);
          var missing = [];
          Object.keys(a.values).forEach(function (k) { if (!setHidden(formEl, k, a.values[k])) missing.push(k); });
          formEl.setAttribute('data-hexo-cta', a.values.lead_cta_id);
          if (missing.length) console.warn('[lead-capture] hidden fields not found on form:', missing.join(', '));
          mount.removeAttribute('aria-busy');
          setStatus('', '');
          var first = formEl.querySelector('input:not([type=hidden]), select, textarea');
          if (first) first.focus();
        },
        onFormSubmit: function () {
          setStatus('Sending…', 'loading');
        },
        onFormSubmitted: function () {
          submitted = true;
          setStatus('Thank you. Your request has been received. We will reply by email within two business days.', 'success');
          window.setTimeout(function () { if (dialog.open) dialog.close(); document.documentElement.classList.remove('hx-lead-open'); }, 6000);
        }
      });
    }).catch(function (err) {
      console.error('[lead-capture]', err);
      mount.removeAttribute('aria-busy');
      clearMount();
      setStatus('The form could not be loaded. Please retry, or email sales@hexoskin.com with your project description.', 'error');
      var retry = document.createElement('button');
      retry.type = 'button'; retry.className = 'button outline hs-retry'; retry.textContent = 'Retry';
      retry.addEventListener('click', function () { mounting = false; mountForm(trigger); });
      mount.appendChild(retry);
    }).finally(function () { mounting = false; });
  }

  function openFor(trigger) {
    lastTrigger = trigger;
    loadConfig().then(function () {
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('hx-lead-open');
      mountForm(trigger);
    }).catch(function (err) {
      console.error('[lead-capture] config', err);
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('hx-lead-open');
      setStatus('The form is unavailable right now. Please email sales@hexoskin.com with your project description.', 'error');
    });
  }

  document.querySelectorAll('[data-request]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openFor(b); });
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('close', function () {
    /* The HubSpot form is destroyed on close so a reopened dialog never carries two forms or two listeners.
     * Visitor input survives only while the dialog is open; a failed submission keeps the form mounted. */
    clearMount();
    setStatus('', '');
    document.documentElement.classList.remove('hx-lead-open');
    if (lastTrigger) lastTrigger.focus();
  });
  /* Chrome defers the dialog close event while the document is hidden, so the scroll lock is also released here. */
  if (closeBtn) closeBtn.addEventListener('click', function () { clearMount(); setStatus('', ''); document.documentElement.classList.remove('hx-lead-open'); });
  window.addEventListener('message', function (ev) {
    if (ev.data && ev.data.type === 'hsFormCallback' && ev.data.eventName === 'onFormFailedValidation') setStatus('Please check the highlighted fields.', 'error');
  });
})();
